<template>
  <div class="container pageAuth">
    <Loader v-if="!loaded" :isLoading="true"></Loader>
    <template v-else>
      <div class="main-container-header">
        <div class="main-container-header__title">
          <img
              height="32"
              width="32"
              :src="require('@/assets/images/icon-account.svg')"
          />
          <h2>Edit Agency Information</h2>
        </div>
      </div>
      <div class="row">
        <div class="m-auto">
          <div id="profile-panel">
            <div
                class="panel panel-success"
                v-if="submitted && resultType === 'success'"
            >
              <div class="panel-heading">
                <h3 class="panel-title">Success</h3>
              </div>
              <div class="panel-body">
                Your changes have been saved.

                <div>
                  <a class="btn btn-primary mt-2" href="/member/profile"
                  >Refresh page</a
                  >
                </div>
              </div>
            </div>

            <div
                class="panel panel-default"
                v-if="!submitted || resultType !== 'success'"
            >
              <div class="panel-body">
                <!--<div class="error-summary" v-if="resultType === 'error'">
                  <div class="alert alert-danger">
                    <div :key="k" v-for="(err, k) in error">
                      {{ k + ": " + err }}
                    </div>
                  </div>
                </div>-->
                <form
                    class="form-signin"
                    method="POST"
                    @submit.prevent="reset();submit();"
                >
                  <div class="form-group">
                    <label>Agency Logo</label>
                    <div v-if="imageURL" class="mb-2">
                      <img :src="imageURL" id="agency-logo"/>
                    </div>
                    <input type="file" id="fileInput" ref="fileInput" @input="uploadImage">
                    <div>
                    <span v-if="!imageURL" class="btn btn-primary" @click="selectImage">Select</span>
                    <span v-if="imageURL" class="btn btn-primary" @click="removeImage">Remove</span>
                    </div>
                    <div v-if="imageError" class="mt-1 text-danger">
                      {{ imageError }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Brand Color</label>
                    <div ref="colorPickerWrapper">
                      <input
                          v-model="form.brand_color"
                          type="text"
                          class="form-control"
                          placeholder="Enter or pick a color"
                          readonly
                          @click="togglePicker"
                          :style="{ color: form.brand_color }"
                      />

                      <chrome-picker
                          v-if="showPicker"
                          :value="form.brand_color"
                          @input="updateColor"
                          @blur="hidePicker"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="checkbox">
                      <label v-b-tooltip.hover="agency.otp_required ? 'OTP cannot be disabled once activated.' : null">
                        <input type="checkbox"
                               v-model="form.otp_required"
                               :disabled="agency.otp_required"> OTP Required
                      </label>
                    </div>
                  </div>
                  <div class="form-group">
                    <label><span class="text-danger"><b>*</b></span> Agency Manager Email</label>
                    <input
                        v-model="form.email_contact"
                        maxlength="255"
                        type="email"
                        class="form-control"
                        placeholder="Your email here"
                        required
                    />
                    <div v-if="error.email" class="mt-1 text-danger ">
                      Email: {{ error.email }}
                    </div>
                  </div>

                  <div class="form-group">
                    <label><span class="text-danger"><b>*</b></span> Agency Alerts Email</label>
                    <input
                        v-model="form.operational_email"
                        maxlength="255"
                        type="email"
                        class="form-control"
                        placeholder="Your alerts email here"
                        required
                    />
                    <div v-if="error.operational_email" class="mt-1 text-danger ">
                      Alerts Email: {{ error.operational_email }}
                    </div>
                  </div>

                  <div class="form-group">
                    <label><span class="text-danger"><b>*</b></span> Company Name</label>
                    <input
                        v-model="form.company_name"
                        maxlength="255"
                        type="text"
                        class="form-control"
                        placeholder="Use legal name"
                        required
                    />
                    <div v-if="error.company_name" class="mt-1 text-danger ">
                      Company Name: {{ error.company_name }}
                    </div>
                  </div>

                  <div class="form-group">
                    <label><span class="text-danger"><b>*</b></span> Agency Address</label>
                    <input
                        v-model="form.address"
                        maxlength="255"
                        type="text"
                        class="form-control"
                        placeholder="Street, number"
                        required
                    />
                    <div v-if="error.address" class="mt-1 text-danger ">
                      Agency Address: {{ error.address }}
                    </div>
                  </div>


                  <div class="form-group">
                    <label><span class="text-danger"><b>*</b></span> Zip code</label>
                    <input
                        v-model="form.postal_code"
                        maxlength="10"
                        type="text"
                        class="form-control"
                        placeholder="Use a valid postal code"
                        required
                    />
                    <div v-if="error.postal_code" class="mt-1 text-danger ">
                      Zip Code: {{ error.postal_code }}
                    </div>
                  </div>

                  <div class="form-group">
                    <label><span class="text-danger"><b>*</b></span> Phone</label>
                    <input
                        v-model="form.phone_contact"
                        maxlength="20"
                        class="form-control"
                        placeholder='Include country code "+XX"'
                        required
                    />
                    <div v-if="error.phone_contact" class="mt-1 text-danger ">
                      Phone: {{ error.phone_contact }}
                    </div>
                  </div>

                  <div class="form-group">
                    <label>IATA/TIDS code</label>
                    <input
                        v-model="form.iata_number"
                        maxlength="10"
                        class="form-control"
                        placeholder="Use a valid IATA/TIDS code"
                    />
                    <div v-if="error.iata_number" class="mt-1 text-danger">
                      IATA/TIDS code: {{ error.iata_number }}
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Hahn Air ID</label>
                    <input
                        v-model="form.hr_agency_id"
                        maxlength="10"
                        class="form-control"
                        placeholder="Hahn Air ID"
                    />
                    <div v-if="error.hr_agency_id" class="mt-1 text-danger">
                      Hahn Air ID: {{ error.hr_agency_id }}
                    </div>
                  </div>

                  <div class="form-group">
                    <label>City Name</label>
                    <input
                        v-model="form.city_name"
                        maxlength="10"
                        type="text"
                        class="form-control"
                        placeholder="e.g. Madrid"
                    />
                    <div v-if="error.city_name" class="mt-1 text-danger ">
                      City Name: {{ error.city_name }}
                    </div>
                  </div>

                  <div class="form-group">
                    <label>City Code</label>
                    <input
                        v-model="form.city_code"
                        maxlength="10"
                        type="text"
                        class="form-control"
                        placeholder="e.g. MAD"
                    />
                    <div v-if="error.city_code" class="mt-1 text-danger ">
                      City Code: {{ error.city_code }}
                    </div>
                  </div>

                  <div class="form-group">
                    <label>State Prov</label>
                    <input
                        v-model="form.state_prov"
                        maxlength="10"
                        type="text"
                        class="form-control"
                        placeholder="e.g. Valencia"
                    />
                    <div v-if="error.state_prov" class="mt-1 text-danger ">
                      State Prov: {{ error.state_prov }}
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Currency Code</label>
                    <input
                        v-model="form.currency_code"
                        maxlength="10"
                        type="text"
                        class="form-control"
                        placeholder="e.g. EUR"
                    />
                    <div v-if="error.currency_code" class="mt-1 text-danger ">
                      Currency Code: {{ error.currency_code }}
                    </div>
                  </div>

                  <div class="form-action">
                    <button class="btn btn-primary" type="submit">Save</button>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from '@/services/axios';
import helpers from "../mixins/helpers";
import Loader from './shared/+loader'
import data from "@/services/data";
import { Chrome } from 'vue-color';


export default {
  data: function () {
    return {
      loaded: false,
      agency: {},
      form: {},
      error: {},
      submitted: false,
      agencyFields: [],
      resultType: '',
      // plans: [],
      priorPlanID: '',
      imageError: '',
      imageURL: '',
      showPicker: false,
    }
  },
  mixins: [
    helpers,
  ],
  components: {
    Loader,
    'chrome-picker': Chrome,
  },
  mounted: function () {
    this.init();
    document.addEventListener('click', this.handleClickOutside);
  },
  methods: {
    init: function () {
      // let p1 = axios.get('/front/plans/list').then((res) => {
      //   let result = res.data;
      //   this.plans = result.data;
      // });
      if (this.can('front.agency.settings')) {

        let p2 = axios.get('/agent/account/data').then((res) => {
          let result = res.data;
          if (result.error) {
            this.error = result.error;
          } else if (result.status === 'OK') {
            this.agency = result.data;
            this.form.username = result.data.email;

            if (result.data) {
              this.form = {
                operational_email: result.data.operational_email,
                email_contact: result.data.email_contact,
                company_name: result.data.company_name,
                address: result.data.address,
                postal_code: result.data.postal_code,
                phone_contact: result.data.phone_contact,
                iata_number: result.data.iata_number,
                hr_agency_id: result.data.hr_agency_id,
                city_code: result.data.city_code,
                city_name: result.data.city_name,
                currency_code: result.data.currency_code,
                state_prov: result.data.state_prov,
                brand_color: result.data.brand_color || '#A70000',
                otp_required: result.data.otp_required,
              }
              this.imageURL = result.data.agency_image_url;
            }
          }
        }).catch()

        Promise.all([p2]).then(() => {
          setTimeout(() => {
            this.loaded = true
          }, 200);
        })
      }
    },
    reset: function () {
      this.error = '';
    },
    submit: function () {
      this.form['prior_plan_id'] = this.priorPlanID
      axios.post('/agent/account/data', this.form).then((res) => {
        let result = res.data;
        this.error = {};
        this.submitted = true;
        if (result.status === 'OK') {
          this.resultType = 'success';
        } else {
          this.error = result.error || result;
          this.resultType = 'error';
        }
      }).catch()
    },
    selectImage: function () {
      this.$refs['fileInput'].click()
    },
    uploadImage: function (event) {
      this.imageError = '';
      let photo = event.target.files[0];
      let formData = new FormData();
      formData.append("file", photo);
      axios.post('/agent/account/upload-logo', formData).then((res) => {
        this.imageURL = res.data.meta;

      }).catch(res => {
        if (res.response) {
          if (res.response.data.error) {
            this.imageError = res.response.data.error;
          }
        } else {
          console.error(res)
        }
      })
    },
    removeImage: function () {
      axios.post('/agent/account/remove-logo', '').then((res) => {
      this.imageError = '';
      this.imageURL = '';
      }).catch(res => {
        if (res.response) {
          if (res.response.error) {
            this.imageError = res.response.error;
          }
        } else {
          console.error(res)
        }
      })
    },
    togglePicker() {
      this.showPicker = !this.showPicker;
    },
    updateColor(newColor) {
      this.form.brand_color = newColor.hex;
    },
    hidePicker() {
      this.showPicker = false;
    },
    handleClickOutside(event) {
      if (!this.$refs.colorPickerWrapper.contains(event.target)) {
        this.hidePicker();
      }
    }
    /*isConsumerOwner() {
      return this.$localStorage.get('isConsumerOwner') === 'true';
    },*/
  },
  computed: {
    countries() {
      return data.countries
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

#agency-logo {
  min-height: 50px;
  min-width: 75px;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 3px;
  max-height: 200px;
  max-width: 200px;
}

#fileInput {
  display: none;
}

#app {
  .container {
    &.pageAuth {
      max-width: 600px;

      p {
        font-size: 1.1rem;
        font-weight: 300;

        &.forgotLink {
          margin: 0;

          a {
            font-size: 1rem;
            font-weight: 500;
          }
        }
      }

      form {
        position: relative;

        label {
          font-size: 1.2rem;
          color: #000000;
          margin-top: 0.7rem;
          margin-bottom: 0.3rem;
        }
      }

      .formMainAction {
        margin-top: 2rem;

      }

      .form-group {
        margin-bottom: 0.5rem;
      }

      .form-action {
        margin-top: 1.5rem;
      }

      .form-control {
        border: 1px solid #e0e0e0;
        height: calc(3rem + 2px);
        background-color: white;

        &:focus {
          background-color: white;
          border: 2px solid #606060;
        }
      }
    }
  }

  #profile-panel {
    width: calc(600px - 2rem);
    border: 1px solid #d9e4f3;
    box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.03);
    border-radius: 7px;
    margin-top: 0;
  }

  .panel {
    margin-bottom: 0;
  }

  .file-input {
    display: none;
  }

  .vc-chrome {
    position: absolute;
  }
}

</style>

